import React, { memo, useRef, useState, useEffect } from 'react';
import { Form } from 'antd';
import {
  getProjectMultiModuleSectionColumns,
  getDefaultRowData,
} from '@modules/systemSetting/systemModule/systemModuleColumns';
import { DragableTableFrom as ManageSectionForm } from '@components';
import { addModuleConfig } from '@modules/projects/integrationHub/manageModules/manageMForm/config/add.config';

const FormItem = Form.Item;

function MultiSectionForm({
  field = {},
  defaultValue = [],
  formChange = () => {},
  ...props
}) {
  const [sectionForm] = Form.useForm();
  const fieldMethods = useRef({});

  const registerFieldsMethods = (methods) => {
    fieldMethods.current = methods;
  };

  const handleSortEnd = ({ newIndex, oldIndex }) => {
    const { move } = fieldMethods.current;

    if (move) {
      move(oldIndex, newIndex);
    }
  };

  return (
    <FormItem {...field} {...props} defaultValue={defaultValue}>
      <Form
        form={sectionForm}
        className="integration-manage-form customize-project-home-form"
        scrollToFirstError
        autoComplete="off"
        initialValues={{
          projectHomeTmplt: defaultValue,
        }}
        onValuesChange={(v, v2) => {
          // 这里传v2是对的
          // console.log('是是是 v2: ', v2?.projectHomeTmplt.map(item => ({ ...item, titleName: item.section })));
          sectionForm.validateFields();
          if (Array.isArray(v2?.projectHomeTmplt)) {
            props.onChange(
              v2?.projectHomeTmplt.map((item) => ({
                ...item,
                titleName: item.section,
              })),
            );
          }
        }}
      >
        <div className="dragable-table-form">
          <ManageSectionForm
            columns={getProjectMultiModuleSectionColumns()} // children
            registerFieldsMethods={registerFieldsMethods}
            onSortEnd={handleSortEnd}
            isLoading={false}
            formInstance={sectionForm}
            defaultColumns={getProjectMultiModuleSectionColumns()}
            name="projectHomeTmplt"
            formChange={formChange}
            isActive={true}
            getDefaultRowData={getDefaultRowData}
            addBtnText="Add New Section"
            configs={{ addModuleConfig }}
            showSpn
          />
        </div>
      </Form>
    </FormItem>
  );
}

export default memo(MultiSectionForm);
